import {
  Component,
  OnInit,
  Input,
  Output,
  ViewChild,
  QueryList,
  EventEmitter
} from '@angular/core';
import { Subject } from "rxjs/Subject";
import { UsersService } from '../../injections/users.service';
import "rxjs/add/operator/debounceTime";


@Component({
  selector: 'predictive',
  templateUrl: 'predictive.html'
})

export class PredictiveComponent implements OnInit {

  public selected: number = 0;
  public items: Array<object>;
  public inputValue = null;
  @Input() type;
  @Output() focusInput = new EventEmitter();
  @Output() search = new EventEmitter();
  public predict$ = new Subject<string>();
  constructor(private usersService: UsersService) {
    this.predict$.debounceTime(400)
    .distinctUntilChanged()
    .subscribe(term => {
      if(term != null){
        this.selected = 0;
        this.predictValue(term);
      }
    });
  }

  public mouseOver($event, index) {
    this.selected = index;
  }

  public decrementSelected($event, index) {
    
    if (this.items != null) {

      let element = this.items[index];
      if ($event.key == "ArrowDown") {
        if (this.selected < this.items.length - 1) {
          this.selected++;
        }
      }
      if ($event.key == "ArrowUp") {
        if (this.selected > 0) {
          this.selected--;
        }
      }
      if ($event.key == "Enter") {
        if(element != null){
          this.setItem(element);
        //this.search.emit(element);
        }
      }
    }

  }

  public predictValue(term: string) {
    this.inputValue = term;
    this.focusInput.emit(this.type);
  }

  public setItem(item: any) {
    this.inputValue = item.value;
    this.items = [];
    this.search.emit(item);
  }

  public blurInput(event) {
    this.focusInput.emit(this.type);
  }

  public clearSearch() {
    this.inputValue = null;
    this.items = null;
  }

  ngOnInit() {
    
  }
}



// WEBPACK FOOTER //
// ./src/app/common/predictive/predictive.component.ts